import * as React from 'react';
import cx from 'classnames';
import { observer } from '@formily/react';
import { CnCard as PureCnCard } from '@/components/cn-card';
import './index.scss';
export const CnCard = observer((props) => {
    const { children, ...otherProps } = props;
    return React.createElement(PureCnCard, { ...otherProps }, children);
});
export const CnCardSubCard = observer((props) => {
    const { className, children, ...otherProps } = props;
    return (React.createElement(PureCnCard, { className: cx(className, 'cn-ui-onecode-sub-card'), ...otherProps }, children));
});
